window.APP = {
  apiContext: "/manager/",
  stripeKey : 'pk_live_PI0neRP94a9fQVppK2dIuGl7',
  // squareKey : 'sq0idp-u_EGjfqPcTQE-bqDCt4Z0A',
  squareKey : 'sq0idp-u_EGjfqPcTQE-bqDCt4Z0A',
  appVersion : 'genbook.com-gcp-1.12.1',
  apiDomain: "https://www.eunw.genbook.com",
  apiPath: "https://www.eunw.genbook.com/manager/",
  CONFIGURATION: {
    VALIDATION: {
      CountryCode: "us",
    },
  },
};

var reg = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n?]+)/gim;
if (window.document.referrer) {
  window.APP.apiDomain = reg.exec(window.document.referrer)[0];
  window.APP.apiPath = window.APP.apiDomain + window.APP.apiContext;
} else {
  window.APP.apiDomain = "https://www.eunw.genbook.com";
  window.APP.apiPath = window.APP.apiDomain + window.APP.apiContext;
}

// if (window.location.href.indexOf('localhost') > -1){
//       window.SERVICE_PROVIDER_ID = 30021098; //get this id in order to develop locally
//       let parsedToken = decodeURIComponent('GENBOOK-TOKEN+chrisf%40genbook.com%3A20180523T030726Z%3Auynf9kqPczIt5vedtVmlYTkVRZI1Tk5smzLoDa1n8kBbOZ2pOWuH5v5Jyj4dc9zYYA42s8yR5SB4t%2B4kepD5kg'); // remove the ; !!
//       parsedToken = decodeURIComponent(parsedToken).replace('+',' ')
//       window.sessionStorage.setItem('token_authorization', parsedToken);
// }
